interface IconProps {
  className?: string;
}

export function ReportGeneratedIcon({ className = '' }: IconProps) {
  return (
    <svg 
      className={className}
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M19 11C19 10.182 19 9.43 18.848 9.063C18.696 8.696 18.407 8.406 17.828 7.828L13.092 3.092C12.593 2.593 12.344 2.344 12.034 2.196C11.9698 2.16518 11.9041 2.13781 11.837 2.114C11.514 2 11.161 2 10.456 2C7.211 2 5.588 2 4.489 2.886C4.26709 3.06494 4.06494 3.26709 3.886 3.489C3 4.59 3 6.211 3 9.456V14C3 17.771 3 19.657 4.172 20.828C5.344 21.999 7.229 22 11 22H19M12 2.5V3C12 5.828 12 7.243 12.879 8.121C13.757 9 15.172 9 18 9H18.5" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M21 14H19C18.7348 14 18.4804 14.1054 18.2929 14.2929C18.1054 14.4804 18 14.7348 18 15V16.5M18 16.5V19M18 16.5H20.5M7 19V17M7 17V14H8.5C8.89782 14 9.27936 14.158 9.56066 14.4393C9.84196 14.7206 10 15.1022 10 15.5C10 15.8978 9.84196 16.2794 9.56066 16.5607C9.27936 16.842 8.89782 17 8.5 17H7ZM12.5 14H13.786C14.733 14 15.5 14.746 15.5 15.667V17.333C15.5 18.253 14.732 19 13.786 19H12.5V14Z" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}
